import DynamicModal from './DynamicModal'
export default DynamicModal
